"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FilterContainer = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var FilterContainer = function FilterContainer(_ref) {
  var _ref$onSubmit = _ref.onSubmit,
      onSubmit = _ref$onSubmit === void 0 ? function () {} : _ref$onSubmit,
      _ref$onCancel = _ref.onCancel,
      onCancel = _ref$onCancel === void 0 ? function () {} : _ref$onCancel,
      _ref$loading = _ref.loading,
      loading = _ref$loading === void 0 ? false : _ref$loading,
      children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "filterContainer",
    children: children
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "filterContent"
  }, loading ? /*#__PURE__*/_react["default"].createElement("div", null, " loading!!!") : children), /*#__PURE__*/_react["default"].createElement("div", {
    className: "Footer"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    onClick: onCancel,
    className: 'filterContainerActionButton cancel'
  }, "Cancel"), /*#__PURE__*/_react["default"].createElement("button", {
    onClick: onSubmit,
    className: 'filterContainerActionButton apply'
  }, "Apply")));
};

exports.FilterContainer = FilterContainer;